import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["action", "ariaLabel", "ariaLabelledBy", "autoComplete", "children", "method", "name", "noValidate", "onBlur", "onSubmit"];
import { useRef, useCallback } from 'react';
import { normalizeAutocomplete, requestSubmit } from './Form.helpers';
import { useMaybeStopPropagation } from '../AppProvider/PropagationProvider';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledForm = styled.form.withConfig({
  displayName: "Form__StyledForm",
  componentId: "sc-153egeb-0"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
export const Form = _ref => {
  let {
      action,
      ariaLabel,
      ariaLabelledBy,
      autoComplete,
      children,
      method,
      name,
      noValidate,
      onBlur,
      onSubmit
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const form = useRef(null);
  const {
    maybeStopPropagation
  } = useMaybeStopPropagation();
  const handleOnKeyDown = useCallback(event => {
    if (event.key === 'Enter' && (!event.ctrlKey || !event.metaKey)) {
      maybeStopPropagation(event);
    }
    if (event.key === 'Enter' && (event.ctrlKey || event.metaKey) && form.current) {
      maybeStopPropagation(event);
      event.preventDefault();
      requestSubmit(form.current);
    }
  }, [maybeStopPropagation]);
  const handleOnSubmit = useCallback(event => {
    maybeStopPropagation(event);
    if (!action && !onSubmit) {
      event.preventDefault();
    }
    if (typeof onSubmit === 'function') {
      onSubmit(event);
    }
  }, [action, onSubmit, maybeStopPropagation]);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledForm, Object.assign({
    action: action,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    autoComplete: normalizeAutocomplete(autoComplete),
    method: method,
    name: name,
    noValidate: noValidate,
    onKeyDown: handleOnKeyDown,
    onBlur: onBlur,
    onSubmit: handleOnSubmit,
    ref: form,
    $cssStyles: cssStyles
  }, domProps, {
    children: children
  }));
};